// extracted by mini-css-extract-plugin
export var numpadContainer = "_r9-1";
export var phoneButton = "_r9-0";